import React, { useMemo, useState } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import KnightActiveLevel1 from '@static/images/knight_active_level1.svg';
import styles from './UIGameActionButtonKnightActions.module.scss';
import commonStyles from '../UIGameActionButtonContainer.module.scss';
import { UIGameActionButtonKnightPlacement } from './UIGameActionButtonKnightPlacement/index.ts';
import { UIGameActionButtonKnightMove } from './UIGameActionButtonKnightMove/index.ts';
import { UIGameActionButtonKnightUpgrade } from './UIGameActionButtonKnightUpgrade/index.ts';
import { UIGameActionButtonKnightActivation } from './UIGameActionButtonKnightActivation/index.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { TurnState } from '@colonist/game-states';
import clsx from 'clsx';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
export const UIGameActionButtonKnightActions = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const currentStateValidator = useCurrentStateValidator();
    const isInitialPlacement = currentState.turnState === TurnState.InitialPlacement;
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor);
    const disabled = isPaused || isInitialPlacement || isNotMyTurn;
    const isOpen = useGameStore((state)=>state.gameActionButtons.isKnightActionExtraButtonsOpen);
    const setKnightActionExtraButtonsOpen = useGameStore((state)=>state.gameActionButtons.setKnightActionExtraButtonsOpen);
    const [childButtonStates, setChildButtonStates] = useState({
        placement: false,
        activation: false,
        upgrade: false,
        move: false
    });
    const handleButtonClick = ()=>{
        setKnightActionExtraButtonsOpen(!isOpen);
    };
    const hasAnyChildActionActive = useMemo(()=>Object.values(childButtonStates).some((isDisabled)=>!isDisabled), [
        childButtonStates
    ]);
    const isDisabledWithChildActions = disabled || !hasAnyChildActionActive;
    const handleChildDisabledChange = (buttonType)=>(isDisabled)=>{
            setChildButtonStates((prev)=>({
                    ...prev,
                    [buttonType]: isDisabled
                }));
        };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        disabled: isDisabledWithChildActions,
        onClick: handleButtonClick,
        onClickActionIfDisabled: handleButtonClick,
        iconPath: KnightActiveLevel1,
        tooltipPosition: "bottom",
        tooltipTitle: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.knight"
        })
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.extraButtons, {
            [styles.hidden]: !isOpen
        })
    }, /*#__PURE__*/ React.createElement(UIGameActionButtonKnightPlacement, {
        className: commonStyles.actionButton,
        onDisabledChange: handleChildDisabledChange('placement')
    }), /*#__PURE__*/ React.createElement(UIGameActionButtonKnightActivation, {
        className: commonStyles.actionButton,
        onDisabledChange: handleChildDisabledChange('activation')
    }), /*#__PURE__*/ React.createElement(UIGameActionButtonKnightUpgrade, {
        className: commonStyles.actionButton,
        onDisabledChange: handleChildDisabledChange('upgrade')
    }), /*#__PURE__*/ React.createElement(UIGameActionButtonKnightMove, {
        className: commonStyles.actionButton,
        onDisabledChange: handleChildDisabledChange('move')
    })));
};
